import {Injectable} from '@angular/core';
import {ApiClientService} from './api-client.service';
import {SettingsPassOnLog} from '../types/data.types';
import {UrlService} from './url.service';
import {EmptyRowService} from './empty-row.service';
import {EmailService} from './email.service';
import {AccountPermissionsService} from './account-permissions.service';
import {tap} from 'rxjs/operators';
import {createInitialNetworkEntity, resolveNetworkEntity} from './helper-functions';

declare const toastr: any;
declare const swal: any;
declare const $: any;

@Injectable()
export class SettingsPassOnLogService {
    data = {
        allSettingsPassOnLog: {
            get: '/v1/settings?expand=showPopupUponDashboard',
            data: [],
            total: null
        },
    };
    showCreateModal = false;
    isDisabledDatesModalShow = false;
    isLegalAgreementModalShow = false;
    isNotificationModalShow = false;
    showDetailedView = true;
    selectedItemData: SettingsPassOnLog;
    spinnerShow = false;
    buildings: Array<any> = [];
    buildingsForRead: Array<any> = [];
    buildingsForUpdate: Array<any> = [];
    buldingsInMultiselectFormat: Array<any> = [];
    selectedItemFormattedBuildingsArray: Array<any> = [];
    modalSpinnerShow = false;
    showServiceUnavailable = false;
    serviceName: string = 'pass_on_log';
    userRoles: Array<any> = [];
    createdStaffMultiselectArray: Array<any> = [];
    readStaffMultiselectArray: Array<any> = [];
    updatedStaffMultiselectArray: Array<any> = [];
    deletedStaffMultiselectArray: Array<any> = [];
    passCreatedStaffCheckbox = false;
    passReadStaffCheckbox = false;
    passUpdatedStaffCheckbox = false;
    passDeletedStaffCheckbox = false;
    notificationModalStaffOrResident = '';
    notificationModalNotificationType = '';
    corporations: any = {
        data: [],
        total: null
    };

    constructor(public es: EmailService,
                public api: ApiClientService,
                public urlService: UrlService,
                public emptyRowService: EmptyRowService,
                public account: AccountPermissionsService
    ) {
        this.api.onLogout.subscribe(() => this.buildings = []);
    }

    getBuildings(): void {
        if (this.buildings.length) return;
        const url = `/v1/buildings/short.json?order-by=name|asc`;
        this.api.getInfiniteList('domainBD', url, 1000).subscribe(
            (res) => {
                this.buildings = res.entities;
                this.getFilteredBuildings();
            },
            (error) => this.api.errorHandler(error, 'Failed get buildings')
        );
    }

    resetData() {
        this.corporations.data = [];
        this.corporations.total = null;
    }

    canEdit(buildingId?: number) {

        return this.account.canUpdate(this.serviceName, buildingId);
    }

    canDelete(buildingId?: number) {

        return this.account.canDelete(this.serviceName, buildingId);
    }

    getFilteredBuildings() {
        this.buildingsForRead = this.account.getBuildingsForRead(this.buildings, this.serviceName);
        this.buildingsForUpdate = this.account.getBuildingsForUpdate(this.buildings, this.serviceName);
        this.buldingsInMultiselectFormat = this.getBuildingsInProperFormat(this.buildings);
    }

    getBuildingsInProperFormat(arr: Array<any>) {
        return arr.map(
            building => (
                {id: parseInt(building.id), itemName: building.name}
            )
        );
    }

    public getUserRoles() {
        const url = `/api/v1/role.json`;
        this.api.getInfiniteList('oauthUrl', url, 1000).subscribe(
            res => {
                this.userRoles = [];
                res.entities.map(role => this.userRoles.push({id: role.id, itemName: role.name}));
            },
            error => this.api.errorHandler(error, 'Failed get Roles')
        );
    }

    public formatNotificationSettingsRoles(): any {
        if (this.selectedItemData) {
            this.selectedItemData.staffNotificationSettings.forEach((notificationSetting) => {
                const actionPart = notificationSetting.action != 'picked_up' ? (notificationSetting.action.charAt(0).toUpperCase() + notificationSetting.action.slice(1)) : 'PickedUp';
                this['parcel' + actionPart + 'StaffCheckbox'] = notificationSetting.enableStatus;
                notificationSetting.userRoles.forEach((role) => {
                    const action = notificationSetting.action == 'picked_up' ? 'pickedUp' : notificationSetting.action;
                    this[action + 'StaffMultiselectArray'].push({
                        id: role.bdId,
                        itemName: role.roleName
                    });
                });
            });
            this.selectedItemData.residentsNotificationSettings.forEach((resNotification) => {
                const actionPart = resNotification.action != 'picked_up' ? (resNotification.action.charAt(0).toUpperCase() + resNotification.action.slice(1)) : 'PickedUp';
                this['parcel' + actionPart + 'ResidentCheckbox'] = resNotification.enableStatus;
            });

        }
    }

    emptyNotificationArrays(): void {
        this.createdStaffMultiselectArray = [];
        this.readStaffMultiselectArray = [];
        this.updatedStaffMultiselectArray = [];
        this.deletedStaffMultiselectArray = [];
        this.passCreatedStaffCheckbox = false;
        this.passReadStaffCheckbox = false;
        this.passUpdatedStaffCheckbox = false;
        this.passDeletedStaffCheckbox = false;
    }

    settingsPassOnLogFactory(pass) {
        const settingsPassOnLog = new SettingsPassOnLog();

        if (pass.id) settingsPassOnLog.id = pass.id;
        if (pass.corporationNumberBdId) settingsPassOnLog.corporationNumberBdId = pass.corporationNumberBdId;
        if (pass.showPopupUponDashboard) {
            settingsPassOnLog.showPopupUponDashboard = pass.showPopupUponDashboard;
            settingsPassOnLog.showPopupUponDashboard.roles = settingsPassOnLog.showPopupUponDashboard.roles.map(r => ({
                id: r.bdId,
                itemName: r.name
            }));
        }
        settingsPassOnLog.isCanEdit = pass.isCanEdit;
        settingsPassOnLog.isCanDelete = pass.isCanDelete;

        return settingsPassOnLog;
    }

    toggleDetailedView(data, state: boolean): void {
        this.selectedItemData = data ? data : null;
        this.corporations.data.forEach(item => item.checked = false);
        if (state) {
            data.checked = true;
            this.emptyNotificationArrays();
            this.getSettingsForCorporation(data.id);
        }
        this.showDetailedView = state;
    }

    getSettingsForCorporation(corporationNumberId) {
        const corporationName = (<any>this.selectedItemData).name;
        this.showServiceUnavailable = false;
        this.selectedItemData = null;
        const url = `/v1/settings/${corporationNumberId}.json?expand=showPopupUponDashboard`;
        this.api.get('domainPassOnLog', url).subscribe(
            res => {
                const body = JSON.parse(res._body);
                this.selectedItemData = body ? this.settingsPassOnLogFactory(body) : new SettingsPassOnLog();
                this.selectedItemData.corporationNumberName = corporationName;
                this.formatNotificationSettingsRoles();
            },
            error => {
                if (error.statusText == 'Not Found') {
                    this.selectedItemData = new SettingsPassOnLog();
                    this.selectedItemData.id = corporationNumberId;
                } else
                    this.api.errorHandler(error, 'Failed to get pass on log settings for the chosen corporation');
            }
        );
    }

    getCorporations(scrollToTop?): void {
        this.getCorporationsByQueryParams(scrollToTop).subscribe();
    }

    getCorporationsByQueryParams(scrollToTop?) {
        this.showServiceUnavailable = false;
        this.spinnerShow = true;
        let queryParams = this.urlService.getQueryParamsString();
        if (queryParams && queryParams.indexOf('&order-by=') != -1)
            queryParams = queryParams.slice(0, queryParams.indexOf('&order-by='));
        const url = `/v1/corporation_number.json?${queryParams}&expand=buildings`;
        return this.api.getJson('domainBD', url)
            .pipe(
                createInitialNetworkEntity(),
                resolveNetworkEntity(),
                tap(({loading}) => this.spinnerShow = loading),
                tap(
                    (res) => {
                        this.corporations.data = res.entities;
                        this.corporations.total = res.total;
                        this.emptyRowService.fillEmptyRow();
                        if (scrollToTop && $('.table')[0])
                            $('.table')[0].scrollIntoView();
                    },
                    (error) => {
                        this.showServiceUnavailable = true;
                        this.spinnerShow = false;
                        this.api.errorHandler(error, 'Failed get corporations');
                    }
                )
            );
    }
}



// WEBPACK FOOTER //
// /app/src/app/services/settings-pass-on-log.service.ts